import { render, staticRenderFns } from "./ReminderDaysForm.vue?vue&type=template&id=f4be0ede&scoped=true"
import script from "./ReminderDaysForm.vue?vue&type=script&lang=js"
export * from "./ReminderDaysForm.vue?vue&type=script&lang=js"
import style0 from "./ReminderDaysForm.vue?vue&type=style&index=0&id=f4be0ede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4be0ede",
  null
  
)

export default component.exports